module.exports = __webpack_public_path__ + "img/logo-white.9e3af4be.svg";